import React from 'react'
import './AnalyticsRating.less'
import { MarbleColor } from '../../../../components/common/marble-rating/Marble'
import { SmallMarbleRating } from '../../../../components/common/marble-rating/SmallMarbleRating'

export interface IAnalyticsRatingProps {
  color?: MarbleColor
  total: number
  value: number
  order: number
}

export function AnalyticsRating({
  color,
  total,
  value,
  order
}: IAnalyticsRatingProps) {
  return (
    <div className={`AnalyticsRating AnalyticsRating--${color}`}>
      <span className="AnalyticsRating__order">{order}</span>
      <SmallMarbleRating rating={order} />
      <div className="AnalyticsRating__progress__wrapper">
        <span
          className="AnalyticsRating__progress"
          style={{ width: `${(value / total) * 100}%` }}
        >
          <span className="AnalyticsRating__progress__value">{value}</span>
        </span>
      </div>
    </div>
  )
}
